class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverTimeout = null;

    // Hover for desktop only
    this.initHoverBehavior();

    // Prevent summary toggle when clicking parent link
    this.preventParentLinkToggle();
  }

  initHoverBehavior() {
    const mediaQuery = window.matchMedia('(min-width: 990px)');

    const toggleHover = () => {
      if (mediaQuery.matches) {
        this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
        this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      } else {
        this.removeEventListener('mouseenter', this.onMouseEnter.bind(this));
        this.removeEventListener('mouseleave', this.onMouseLeave.bind(this));
      }
    };

    toggleHover();
    mediaQuery.addEventListener('change', toggleHover);
  }

  preventParentLinkToggle() {
    const parentLink = this.querySelector('.header__menu-parent-link');
    parentLink?.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  }

  onMouseEnter() {
    clearTimeout(this.hoverTimeout);
    this.hoverTimeout = null;

    if (!this.mainDetailsToggle.open) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    }
  }

  onMouseLeave() {
    this.hoverTimeout = setTimeout(() => this.close(), 200);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
